const routes = [
  {
    path: '/calls',
    name: 'calls',
    component: () => import('@/views/Llamadas/Llamadas')
  },
  {
    path: '/calls/managment',
    name: 'managmentcalls',
    component: () => import('@/views/Llamadas/AdministrarTelefonia')
  },
  {
    path: '/calls/managment/channel',
    name: 'managmentchannel',
    component: () => import('@/views/Llamadas/AdministrarCanal')
  }
]

export default routes
